import { ProductType } from '../../common/product/product';

export function mapResourceTypeToProductType(resourceType: string): ProductType {
    return resourceType === 'user' ? ProductType.USER_BASED : ProductType.ASSET_BASED;
}
